<div>
  <div class="profile-form">
    <div fxLayout="row">
      <div fxLayout="column" fxLayoutAlign="center" fxFlex="1 2 auto">
        <div class="color-city-neutral font-size-small-text-bold">
          {{ "site_member_validation_lbl_name" | translate }}
        </div>
        <div class="color-dark-blue font-size-body-text display-label-detail">
          {{ displayfullname }}
        </div>

        <div class="color-city-neutral font-size-small-text-bold">
          {{ "site_member_validation_lbl_phone" | translate }}
        </div>
        <div class="color-dark-blue font-size-body-text display-label-detail">
          {{ currentUser?.mobileNumber }}
        </div>

        @if (objCompliance?.companyName) {
        <div class="color-city-neutral font-size-small-text-bold">
          {{ "site_member_validation_lbl_company" | translate }}
        </div>
        }
        <div class="color-dark-blue font-size-body-text display-label-detail">
          {{ objCompliance?.companyName }}
        </div>

        @if (profileInductionModuleEnable) {
        <span>
          <div class="color-city-neutral font-size-small-text-bold">
            {{ "site_member_validation_lbl_induction" | translate }}
          </div>
          @if (displayinductionno !== '') {
          <div class="color-dark-blue font-size-body-text display-label-detail">
            {{ displayinductionno }}
          </div>
          } @if (displayinductionno === '') {
          <div class="display-empty">-</div>
          }
          <div class="color-city-neutral font-size-small-text-bold">
            {{ "site_member_validation_lbl_expiry" | translate }}
          </div>
          @if (displayinductionexpirydate !== '') {
          <div class="color-dark-blue font-size-body-text display-label-detail">
            {{ displayinductionexpirydate }}
          </div>
          } @if (displayinductionexpirydate === '') {
          <div class="display-empty">-</div>
          }
        </span>
        }
      </div>

      <div fxLayoutAlign="end start" fxFlex="1 2 auto">
        @if (profileImgLink) {
        <img
          src="{{ profileImgLink }}"
          (error)="profileImgLink = ''"
          class="profile-image"
        />
        } @if (!profileImgLink) {
        <mat-icon class="profile-image-empty-icon">account_circle</mat-icon>
        }
      </div>
    </div>
    <div class="divider"></div>
    <mat-divider></mat-divider>

    @if (profileRapidGlobalRequired) {
    <span>
      <div class="divider"></div>
      <div fxLayout="row">
        <div class="color-city-blue font-size-body-text-bold">
          {{ "site_member_validation_lbl_compliancecheck" | translate }}
        </div>
      </div>
      <div class="induction-button-display induction-card-container">
        <div fxLayout="row" fxFlex="100">
          <div fxLayoutAlign="start center" class="induction-button-img">
            <img class="site-image" src="/assets/RapidGlobalLogo.png" />
          </div>
          <div
            fxLayout="column"
            class="induction-button-msg"
            fxLayoutAlign="center center"
          >
            @if (objCompliance?.statusId) {
            <div class="induction-status">
              {{ getCompliantStatus(objCompliance?.statusId) }}
            </div>
            }
          </div>
          <div class="induction-button-icon induction-button-icon-actions" fxLayoutAlign="center center">
            @if (objCompliance?.statusId ===
            enumCityComplianceStatus.COMPLIANT || objCompliance?.companyName
            == defaultCityFMCompanyName || objCompliance?.companyName ==
            defaultCityFMAsiaCompanyName) {
            <mat-icon class="color-city-green">task_alt</mat-icon>
            } @if (objCompliance?.statusId ===
            enumCityComplianceStatus.NOTCOMPLIANT) {
            <mat-icon class="color-city-red">error</mat-icon>
            } @if (objCompliance?.statusId ===
            enumCityComplianceStatus.NOTAPPLICABLE) {
            <div
              class="induction-status-indicator"
              fxLayout="column"
              fxLayoutAlign="center center"
            >
              <span class="na-icon induction-action-label">{{ "site_compliance_status_error_message_icon" | translate }}</span>
            </div>
            }
          </div>
        </div>
      </div>
    </span>
    }

    @if (profileInductionModuleEnable) {
    <span>
      <div class="divider"></div>
      <div fxLayout="row">
        <app-induction-card-status style="width: 100%; display: block;"></app-induction-card-status>
      </div>
    </span>
    }

    <span>
      <div class="divider"></div>
      <div fxLayout="row">
        <div class="color-city-blue font-size-body-text-bold">
          {{ "site_member_validation_lbl_reason_for_visit_list" | translate }}
        </div>
      </div>
      @if (!isJobReason()) {
      <div>
        <div class="divider"></div>
        @for (reason of siteVisitReasons; track reason) {
        <div fxLayout="row" fxLayoutAlign="center">
          <div fxLayout="column" fxFlex="95">
            @if (reason.calloutReferenceNumber != '') {
            <li class="color-city-blue">{{ reason.calloutReferenceNumber }}</li>
            }
          </div>
        </div>
        }
      </div>
      } @if (isJobReason()) {
      <div>
        @if (allocatedJobs.length > 0) {
        <div>
          <div class="divider"></div>
          <ul class="color-city-blue">
            @for (job of allocatedJobs; track job) {
            <li>
              <span>#{{ job.referenceNumber }}</span
              ><br />
              <span>{{ job.faultServiceName }}</span
              ><br />
              @if (job.eta != null) {
              <div>
                @if (isReactiveJob(job)) {
                <span>ETA: {{ job.eta | date : "dd-MM-yyyy hh:mm a" }}</span>
                } @if (isPPMJob(job)) {
                <span>Due On: {{ job.eta | date : "dd-MM-yyyy" }}</span>
                }
              </div>
              }
              <div class="divider"></div>
            </li>
            }
          </ul>
        </div>
        }
      </div>
      }
      <div class="divider"></div>
      <mat-divider></mat-divider>
    </span>

    @if (permitQnA) {
    <span>
      <div class="divider"></div>
      <div fxLayout="row">
        <div class="color-city-blue font-size-body-text-bold">
          {{ "site_member_validation_lbl_workpermit" | translate }}
        </div>
      </div>
      <div fxLayout="row">
        @if (permitQnA.answer && permitQnA.answer == this.permit[1]) {
        <span>{{
          "site_member_validation_lbl_required_workpermit" | translate
        }}</span>
        } @if (permitQnA.answer != this.permit[1]) {
        <span>{{
          "site_member_validation_lbl_notrequired_workpermit" | translate
        }}</span>
        }
      </div>
      <div class="divider"></div>
      <mat-divider></mat-divider>
    </span>
    }

    <span>
      <div class="divider"></div>
      <div fxLayout="row">
        <div class="color-city-blue font-size-body-text-bold">
          {{ "site_member_validation_lbl_visit_sign_off" | translate }}
        </div>
      </div>
      <div fxLayout="row">
        <span>
          <label
            >{{ visitSignOffQnA.question
            }}<span class="color-city-red"> *</span></label
          ><br />
          <mat-radio-group
            [(ngModel)]="visitSignOffQnA.answer"
            (change)="onClickVisitSignOff(visitSignOffQnA.answer!)"
          >
            <mat-radio-button
              id="answer_yes"
              name="detailsMatch"
              value="{{
                'site_member_validation_lbl_visit_sign_off_answer_yes'
                  | translate
              }}"
            >
              {{
                "site_member_validation_lbl_visit_sign_off_answer_yes"
                  | translate
              }} </mat-radio-button
            ><br />
            <mat-radio-button
              id="answer_no"
              name="detailsMatch"
              value="{{
                'site_member_validation_lbl_visit_sign_off_answer_no'
                  | translate
              }}"
            >
              {{
                "site_member_validation_lbl_visit_sign_off_answer_no"
                  | translate
              }}
            </mat-radio-button>
          </mat-radio-group>
        </span>
      </div>
      @if (!visitSignOffQnA.answer) {
      <div>
        <mat-error>{{
          "site_member_validation_lbl_visit_sign_off_required_error" | translate
        }}</mat-error>
      </div>
      }
      <div class="divider"></div>
      <mat-divider></mat-divider>
    </span>
  </div>
</div>
